import React, { useState } from 'react'
import cx from 'classnames'
import { useIntl, FormattedMessage } from 'react-intl'

import ClearRefinements from '~components/search/clear-refinements'
import Refinement from '~components/search/refinement'

const Filters = ({ ages, topics, contentTypes, activityTypes, pageType }) => {
  const { messages } = useIntl()
  const [showFilters, setShowFilters] = useState(false)

  let types = null
  if (pageType === 'Activity' || pageType === 'Video') {
    types = pageType
  } else if (contentTypes) {
    types = contentTypes
  }

  return (
    <div className='lg:w-1/4 px-4 pt-8 lg:pt-0'>
      <button
        onClick={() => setShowFilters(true)}
        className={cx(showFilters ? 'hidden' : 'flex', 'lg:hidden button button-pink mr-auto mb-0 text-base')}
      >
        <div>
          <FormattedMessage id='show-filters' />
        </div>
      </button>
      <div className={cx(showFilters ? 'flex' : 'hidden', 'lg:flex flex-col w-full p-8 bg-gray-light')}>
        <Refinement
          label={messages['age']}
          labelClasses='headline-5 mb-4'
          attribute='ages.name'
          defaultRefinement={ages || null}
        />

        <Refinement
          label={messages['type']}
          labelClasses='headline-5 mt-8 mb-4'
          attribute='type'
          defaultRefinement={types ? [types] : null}
        />

        {pageType === 'Activity' && (
          <Refinement
            label={messages['activity-type']}
            labelClasses='headline-5 mt-8 mb-4'
            attribute='activityType'
            defaultRefinement={activityTypes ? [activityTypes] : null}
          />
        )}

        <Refinement
          label={messages['topic']}
          labelClasses='headline-5 mt-8 mb-4'
          attribute='topics.name'
          defaultRefinement={topics ? [topics] : null}
        />

        {pageType === 'Question' && (
          <Refinement
            label='Question'
            labelClasses='headline-5 mt-8 mb-4'
            attribute='hasQuestion'
            defaultRefinement={[true]}
            hidden
          />
        )}

        <ClearRefinements />
        <button onClick={() => setShowFilters(false)} className='lg:hidden button button-pink mr-auto mb-0 text-base'>
          <div>
            <FormattedMessage id='hide-filters' />
          </div>
        </button>
      </div>
    </div>
  )
}

export default Filters
